module.exports = __webpack_public_path__ + "img/workshop-marker-green-v1.f265e707.png";